<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      field-name="회사명(필수)"
      :board="this.board"
      :is-print="isPrint"
      :options="[{ type: 'text', value: '공정명', label: '공정명' }]"
    />

    <!--    위험성 평가표-->
    <table-risk-appraisal688 class="mt-5" title="공정구분" :value="form.riskAppraisalList" @input="updateList" :isPrint="isPrint" :readonly="board.readonly" :hide-code-number="true" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-8" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import {required} from "vuelidate/lib/validators";
import TableRiskAppraisal688 from "@/components/TableRiskAppraisal688.vue";

export default {
  components: {
    TableRiskAppraisal688,
    PhotoUploadGridModule,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(/*value*/) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.value[key]) {
            this.form[key] = this.value[key];
          }
        }
      },
    },
    form: {
      important: false,
      deep: true,
      handler(/*value*/) {
        console.log("form changed", this.form);

        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.value[key]) {
            this.form[key] = this.value[key];
          }
        }

        this.form.summary = {
          정기위험성평가_사업장명: [],
          정기위험성평가_재해형태: [],
        };

        this.form.summary["정기위험성평가_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        for (const data of this.form.riskAppraisalList) {
          this.form.summary["정기위험성평가_재해형태"].push({
            [data.input_3]: 1,
          });
        }

        this.$emit("input", this.form);
      },
    },
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
      riskAppraisalList: {
        $each: {
          input_3: { required },
        },
      }
    },
  },
  data() {
    return {
      inspectionTitle: "방파제",

      form: {
        stdInfo: {},

        fileList: [],
        riskAppraisalList: [],
        disasters: "",
      },
    };
  },
  methods: {
    updateList(list) {
      this.form.riskAppraisalList = list;

      this.form.disasters = "";
      for (const risk of this.form.riskAppraisalList) {
        this.form.disasters += `${risk.input_3} `;
      }
    },
    checkDate(input) {
      if (Date.parse(this.form.inputB_8) > Date.parse(this.form.inputB_9)) {
        if (input === this.form.inputB_8) {
          this.form.inputB_9 = this.form.inputB_8;
        } else {
          this.form.inputB_8 = this.form.inputB_9;
        }
      }
    },

    validate() {
      this.$v.$touch();  // 모든 검증을 활성화합니다.
      if (this.$v.$invalid) {  // 전체 폼의 유효성 검사를 체크합니다.
        // stdInfo.field_name 필드의 검증을 체크합니다.
        if (!this.$v.form.stdInfo.field_name.required) {
          return "회사명을 반드시 입력해야 합니다";
        }

        // riskAppraisalList 항목들의 유효성 검사를 반복합니다.
        if (this.$v.form.riskAppraisalList.$each.$iter) {
          const keys = Object.keys(this.$v.form.riskAppraisalList.$each.$iter);
          for (const key of keys) {
            if (!this.$v.form.riskAppraisalList.$each.$iter[key].input_3.required) {
              return "재해형태 항목을 반드시 입력해야 합니다";
            }
          }
        } else {
          console.error("검증할 항목의 배열이 존재하지 않습니다.");
          return "검증 구조에 문제가 있습니다.";
        }
      }
    }

  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
